import { Types } from '@store/types';

const initialState = { response: {}, filterField: {}, countResponse: { COMPLETED: 0, PENDING: 0, total: 0 } };

const PhotographyReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_ALL_PHOTOGRAPHY_BY_STATUS:
			if (action.payload.currentPage === 0) return { ...state, response: { ...action.payload } };
			else {
				let totalList = [...state.response.data];
				totalList.push(...action.payload.data);
				let currentResponse = { ...action.payload };
				currentResponse.data = totalList;
				return { ...state, response: currentResponse };
			}
		case Types.SET_PHOTOGRAPHY_FILTER_DATA:
			return { ...state, filterField: { ...action.payload } };
		case Types.SET_PHOTOGRAPHY_COUNT:
			return {
				...state,
				countResponse: {
					...action.payload,
					total: action.payload.COMPLETED + action.payload?.PENDING || 0
				}
			};
		case Types.CLEAR_PHOTOGRAPHY:
			return (state = { response: {}, filterField: {}, countResponse: {} });
		default:
			return state;
	}
};

export default PhotographyReducer;
